import usePaginatedLogList, { withMasterReview } from "../../../hooks/usePaginatedLogList";
import LogListError from "../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button, Checkbox, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const GarbageLogBookList = () => {
  const navigate = useNavigate();
  const { data: filteredData, loading: page_loader, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.company_listin_garbage_records, "records", withMasterReview);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    const FORM_DATA = new FormData();
    try {
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_GARBAGE_LOGBOOK_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const LIST_GARBAGE_LOGBOOK_API = (ship_id) => {
    if (!ship_id) return;
    return loadRecords({ ship_id, garbage_part: "1" });
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "garbage_record_id",
      align: "center",
      key: "garbage_record_id",
      sorter: (a, b) => a.garbage_record_id - b.garbage_record_id,
      render: (garbage_record_id, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {garbage_record_id}
        </span>
      ),
    },
    {
      title: "Role",
      dataIndex: "staff_role",
      align: "center",
      key: "staff_role",
      render: (staff_role, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {staff_role}
        </span>
      ),
    },
    {
      title: "Garbage Type",
      dataIndex: "garbage_type",
      align: "center",
      key: "garbage_type",
      render: (garbage_type, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {garbage_type}
        </span>
      ),
    },
    {
      title: "Qnty Disposed (m3)",
      dataIndex: "quantity_disposed",
      align: "center",
      key: "quantity_disposed",
      render: (quantity_disposed, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {quantity_disposed}
        </span>
      ),
    },
    {
      title: "Method of Disposal",
      dataIndex: "method_of_disposal",
      align: "center",
      key: "method_of_disposal",
      render: (method_of_disposal, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {method_of_disposal}
        </span>
      ),
    },
    {
      title: "Date",
      dataIndex: "log_date_time",
      align: "center",
      key: "log_date_time",

      render: (log_date_time, record) => (
        <span
          style={{
            textDecoration: record?.soft_delete ? "line-through" : "none",
          }}
        >
          {formatDate(log_date_time)}
        </span>
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center" }}>
          <span>Confirm By Master</span>
          <Checkbox
            disabled
            style={{ marginLeft: 8 }}
            checked={filteredData.length > 0 && filteredData.every((item) => item.masterReviewed)}
            indeterminate={
              filteredData.some((item) => item.masterReviewed) &&
              !filteredData.every((item) => item.masterReviewed)
            }
          />
        </div>
      ),
      dataIndex: "reviewed_by_master",
      align: "center",
      key: "reviewed_by_master",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Checkbox disabled checked={record.masterReviewed} />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Confirm By Master
          </span>
        </div>
      ),
    },

    {
      title: "Action Status",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <Tooltip title="View">
            <Button
              type="primary"
              size="small"
              onClick={() => navigate(`/view-garbage-log-com/${btoa(record?.garbage_record_id)}`)}
              style={{ marginLeft: "5px" }}
              icon={<EyeFilled />}
            />
          </Tooltip>
        );
      },
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_GARBAGE_LOGBOOK_API(value);
            }}
          >
            {ship_table_list?.length > 0 && (
              <>
                {ship_table_list.map((ship) => (
                  <>
                    {!ship.soft_delete && (
                      <>
                        <Select.Option key={ship.id} value={ship.id}>
                          {ship.vessel_name}
                        </Select.Option>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </Select>
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Garbage Logbook Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/view-audit-trail-garbage-log-com")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <LogListError error={error} retry={retry} />
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={pagination}
        rowKey="garbage_record_id"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default GarbageLogBookList;
